// colorPalette.ts
export const baseColors: string[] = [
  '#FDAC0F', // orange
  '#FCC759', // yellow
  '#C78402', // gold_saturated
  '#BF9542', // gold_pale
  '#36C799', // green
  '#20795D', // green_dark
  '#86DDC1', // green_pale
  '#103C2E', // green_very_dark
  '#4699C2', // blue_pastel
  '#55C5D1', // blue_pastel_pale
  '#A5A5A5', // gray_pale
  '#595959', // gray_dark
  '#2E2C2C', // gray_very_dark
  '#332A22', // brown_dark
  '#9F8671', // brown_pale
  '#332A23', // brown
  '#1C1715', // black
];
